import { useState, useEffect } from "react";
import { api } from "../api/client";
import type { Partner } from "../types";

export function useAuth() {
  const [user, setUser] = useState<Partner | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get<Partner>("/auth/me")
      .then(setUser)
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const logout = async () => {
    await api.post("/auth/logout", {});
    setUser(null);
    window.location.href = "/";
  };

  return { user, loading, logout };
}
